const state = {
    //fonteDadosEmExecucao: {
    //    idFonte: undefined,
    //    handler: 0
    //},
    fonteDadosExecutada: {
        idFonte: undefined,
        handler: 0
    }
}

const getters = {
    onFonteDadosExecutada: state => state.fonteDadosExecutada,
    //onFonteDadosEmExecucao: state => state.fonteDadosEmExecucao
}

const mutations = {

    setFonteDadosExecutada: (state, idFonte) => {
        state.fonteDadosExecutada =  {
            handler: Math.random(),
            idFonte
        }
    },
    //setFonteDadosEmExecucao: (state, idFonte) => {
    //    console.log('Execucao:', idFonte)
    //    state.fonteDadosEmExecucao =  {
    //        handler: Math.random(),
    //        idFonte
    //    }
    //},

}

export default {
    state,
    mutations,
    getters
}